"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _messaging = require("../../constants/messaging.types");

var _messaging2 = require("../../constants/messaging.constants");

var _CaptureAction = _interopRequireDefault(require("./fields/CaptureAction"));

var _CaptureWithTextAction = _interopRequireDefault(require("./fields/CaptureWithTextAction"));

var RecipientActionsController = function RecipientActionsController(_ref) {
  var control = _ref.control,
      resetField = _ref.resetField;
  return /*#__PURE__*/_react.default.createElement(_material.FormControl, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 1.5
  }, /*#__PURE__*/_react.default.createElement(_material.FormLabel, null, "What, if anything, do you want a recipient to do in order to redeem their gift?")), /*#__PURE__*/_react.default.createElement(_material.FormGroup, null, /*#__PURE__*/_react.default.createElement(_CaptureAction.default, {
    control: control,
    label: "".concat(_messaging2.recipientActionLabels[_messaging.RecipientActionsFields.CaptureDate], "*"),
    description: "* Due to anti-bribery laws: while meeting acceptance may be made obligatory, meeting attendance cannot be required",
    name: _messaging.RecipientActionsFields.CaptureDate
  }), /*#__PURE__*/_react.default.createElement(_CaptureAction.default, {
    control: control,
    label: _messaging2.recipientActionLabels[_messaging.RecipientActionsFields.CapturePhone],
    name: _messaging.RecipientActionsFields.CapturePhone
  }), /*#__PURE__*/_react.default.createElement(_CaptureAction.default, {
    control: control,
    label: _messaging2.recipientActionLabels[_messaging.RecipientActionsFields.CaptureEmail],
    name: _messaging.RecipientActionsFields.CaptureEmail
  }), /*#__PURE__*/_react.default.createElement(_CaptureWithTextAction.default, {
    control: control,
    label: _messaging2.recipientActionLabels[_messaging.RecipientActionsFields.CaptureQuestion],
    name: _messaging.RecipientActionsFields.CaptureQuestion,
    resetField: resetField,
    textFieldName: _messaging.RecipientActionsFields.GifterQuestion
  }), /*#__PURE__*/_react.default.createElement(_CaptureWithTextAction.default, {
    control: control,
    label: _messaging2.recipientActionLabels[_messaging.RecipientActionsFields.CaptureAffidavit],
    name: _messaging.RecipientActionsFields.CaptureAffidavit,
    resetField: resetField,
    textFieldName: _messaging.RecipientActionsFields.GifterAffidavit
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(RecipientActionsController);

exports.default = _default;